var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"projects"}},[_c('Header'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-general"}},[_c('section',{staticClass:"projects-banner"},[_c('div',{staticClass:"projects-bg"},[_c('h2',[_vm._v("My Work")]),_c('p',[_vm._v("Browse through the numerous projects I have worked on recently, take your time")])])])])
}]

export { render, staticRenderFns }